import { DataObjectFieldComparator } from "../../DataObjects/DataObjectFieldComparator";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { FirebaseFile } from "../../FirebaseFile";
import { DataObjectField } from "../DataObjectField";

export class FirebaseDataFirebaseFileField<FirebaseDataType extends DataObjectType> extends DataObjectField<FirebaseFile, FirebaseDataType> {
  getReadableStringRepresentation(value: FirebaseFile): string {
    return value.title;
  }
  encodeString = (value: FirebaseFile) => value.id;
  decodeString = (value: string) => new FirebaseFile();
  encode = (value: FirebaseFile) => value.path;
  decode = (value: any) => new FirebaseFile(typeof value === "string" ? value : undefined);
  allComparators: DataObjectFieldComparator[] = ["is-known", "is-unknown"];

  override isValueValid = (value: any): boolean => {
    return value instanceof FirebaseFile;
  };
}

